import {
  Box,
  Chip,
  Menu,
  MenuItem,
  Typography,
  Paper,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import toastError from "../../errors/toastError";
import api from "../../services/api";
import { i18n } from "../../translate/i18n";

export function TagsKanbanContainer({ ticket }) {
  const [tags, setTags] = useState([]);
  const [selected, setSelected] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);

  useEffect(() => {
    let isMounted = true;
    const loadTags = async () => {
      try {
        const { data } = await api.get(`/tags/list`, { params: { kanban: 1 } });
        if (isMounted) setTags(data);
      } catch (err) {
        toastError(err);
      }
    };

    loadTags();

    if (ticket.tags && ticket.tags.length > 0) {
      setSelected(ticket.tags[0].id);
    }

    return () => {
      isMounted = false;
    };
  }, [ticket.tags]);

  const handleChange = async (tagId) => {
    try {
      if (ticket.tags.length > 0) {
        await api.delete(`/ticket-tags/${ticket.id}`);
      }
      if (tagId !== null) {
        await api.put(`/ticket-tags/${ticket.id}/${tagId}`);
      }
      setSelected(tagId);
      setAnchorEl(null);
    } catch (err) {
      toastError(err);
    }
  };

  const selectedTag = tags.find(tag => tag.id === selected);

  return (
    <Paper
      elevation={0}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        backgroundColor: "#f5f5f5",
        p: 1.2,
        borderRadius: 2,
        mb: 2,
        gap: 1,
        width: "100%",
      }}
    >
      <Typography variant="body2" sx={{ fontWeight: 600 }}>
        Etapa do Kanban:
      </Typography>

      <Box
        onClick={(e) => setAnchorEl(e.currentTarget)}
        sx={{
          flex: 1,
          display: "flex",
          justifyContent: "flex-end",
          cursor: "pointer"
        }}
      >
        <Chip
          label={selectedTag?.name || "Nenhuma"}
          sx={{
            backgroundColor: selectedTag?.color || "#ddd",
            color: "#fff",
            fontWeight: "bold",
            fontSize: "0.75rem",
            px: 1,
            width: "100%",
            borderRadius: 3,
            textAlign: "center",
            justifyContent: "center",
            "&:hover": {
              opacity: 0.9
            }
          }}
        />
      </Box>


      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        PaperProps={{
          sx: {
            minWidth: "220px",
            borderRadius: 2,
            mt: 1,
          },
        }}
      >
        <MenuItem onClick={() => handleChange(null)}>Nenhuma</MenuItem>
        {tags.map(tag => (
          <MenuItem
            key={tag.id}
            onClick={() => handleChange(tag.id)}
            sx={{
              fontWeight: 500,
              color: "#333",
              "&:hover": {
                backgroundColor: "#f0f0f0",
              },
            }}
          >
            {tag.name}
          </MenuItem>
        ))}
      </Menu>
    </Paper>
  );
}
